export const CrmList = ['hubspot', 'pipedrive', 'guesty', 'zoho', 'gohighlevel']
